const WORDS = ["Design", "Strategy", "Engineering", "Growth", "Branding", "Conversion"];

const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-12 md:py-16 border-y border-white/10 bg-[#050A14] overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`font-display font-black uppercase tracking-tight text-6xl md:text-8xl px-8 ${
                i % 2 === 0 ? "text-outline" : "text-white"
              }`}
            >
              {w}
            </span>
            <span className="text-[#1E6BFF] text-4xl md:text-6xl">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
